

export default function LoadingPage(){
    return(
        <div className="loading-page">
            <div className="spinner-page-container">
                <div className="loading-page-spinner"></div>
                <div className="loading-text">Loading, please wait</div>
            </div> 
        </div>
    )
}